import { render, staticRenderFns } from "./OrderInfoMobile.vue?vue&type=template&id=ed24b22c&scoped=true&"
import script from "./OrderInfoMobile.vue?vue&type=script&lang=js&"
export * from "./OrderInfoMobile.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoMobile.vue?vue&type=style&index=0&id=ed24b22c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed24b22c",
  null
  
)

export default component.exports